import { useEffect, useState } from 'react';

const EMPTY = {
  idEmpresa: '',
  idUnidadOrganizacional: '',
  activo: true,
};

export default function EmpresasUnidadesOrgModal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
  empresas = [],
  unidades = [],
}) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (!open) return;
    if (mode === 'edit' && data) {
      setForm({
        idEmpresasUnidadesOrg: data.idEmpresasUnidadesOrg ?? 0,
        idEmpresa: data.idEmpresa != null ? String(data.idEmpresa) : '',
        idUnidadOrganizacional: data.idUnidadOrganizacional != null ? String(data.idUnidadOrganizacional) : '',
        activo: data.activo ?? true,
      });
    } else {
      setForm({ ...EMPTY });
    }
  }, [open, mode, data]);

  if (!open) return null;

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    if (!form.idEmpresa || !form.idUnidadOrganizacional) return;
    const payload = {
      ...form,
      idEmpresa: Number(form.idEmpresa) || 0,
      idUnidadOrganizacional: Number(form.idUnidadOrganizacional) || 0,
      activo: !!form.activo,
    };
    onSubmit?.(payload, mode);
  };

  const Body = (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        paddingLeft: '15%',
        paddingRight: 16,
        overflowY: 'auto',
      }}
    >
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Empresa *</label>
        <br /><br />
        <select
          className="infoField"
          value={form.idEmpresa}
          onChange={(e) => handleChange('idEmpresa', e.target.value)}
        >
          <option value="">Selecciona una empresa</option>
          {empresas.map((emp) => (
            <option key={emp.idEmpresa} value={emp.idEmpresa}>
              {emp.nombre || `Empresa #${emp.idEmpresa}`}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Unidad Organizacional *</label>
        <br /><br />
        <select
          className="infoField"
          value={form.idUnidadOrganizacional}
          onChange={(e) => handleChange('idUnidadOrganizacional', e.target.value)}
        >
          <option value="">Selecciona una unidad</option>
          {unidades.map((uo) => (
            <option key={uo.idUnidadOrganizacional} value={uo.idUnidadOrganizacional}>
              {uo.nombre || `Unidad #${uo.idUnidadOrganizacional}`}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Activo</label>
        <input
          type="checkbox"
          checked={!!form.activo}
          onChange={(e) => handleChange('activo', e.target.checked)}
        />
      </div>
    </div>
  );

  const Footer = (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', paddingRight: 16 }}>
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={handleSubmit}
        disabled={!form.idEmpresa || !form.idUnidadOrganizacional}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  const Wrapper = ({ children }) => (
    <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
      {children}
    </div>
  );

  const Content = (
    <>
      <div className="roles-topbar" style={{ paddingRight: 16 }}>
        <h3 className="roles-title" style={{ marginRight: 0 }}>
          {mode === 'new' ? 'Nueva relación Empresa-UO' : 'Editar relación Empresa-UO'}
        </h3>
        <button className="roles-btn" aria-label="Cerrar" onClick={onClose}>✕</button>
      </div>
      {Body}
      {Footer}
    </>
  );

  if (inline) {
    return <Wrapper>{Content}</Wrapper>;
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(640px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Content}
      </div>
    </div>
  );
}
